import React, { useEffect } from 'react';

interface Props {
  message: string;
  onClose: () => void;
  durationMs?: number;
  action?: { label: string; onClick: () => void };
  error?: boolean;
}

export function Toast({ message, onClose, durationMs = 3000, action, error }: Props) {
  useEffect(() => {
    const id = setTimeout(onClose, durationMs);
    return () => clearTimeout(id);
  }, [onClose, durationMs]);

  return (
    <div
      role="status"
      aria-live="polite"
      className={[
        'fixed top-3 left-1/2 -translate-x-1/2 z-[60] px-4 py-2.5 rounded-md shadow-lg max-w-[90vw]',
        'flex items-center gap-3',
        error ? 'bg-ruby-500 text-white' : 'bg-ink-900 text-white',
      ].join(' ')}
      style={{ paddingTop: 'calc(0.625rem + env(safe-area-inset-top, 0px))' }}
    >
      <p className="font-body text-small font-medium">{message}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="shrink-0 font-body text-small font-bold text-gold-500 hover:text-gold-600 underline btn-focus rounded"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
